import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, Input, Form, Radio, Select } from 'antd'
import firebase from '../utils/firebaseConnect'
import axios from 'axios'
const { Option } = Select
const DivMenu = styled.div`
  width: 100%;
  /* background-color: black; */
  color: white;
  font-size: 1.5rem;
  p {
    font-size: 1rem;
    text-align: left;
  }
`

class FromRegister extends Component {
  state = {
    fromData: {},
    setLoad: false
  }
  componentDidMount() {}
  handleSubmit = (e, props) => {
    const { SelectPage } = props
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({ setLoad: true })
        console.log('Received values of form: ', values)
        let checkObj = values
        checkObj.createDate = new Date()
        if (!checkObj.lineId) {
          checkObj.lineId = '-'
        }
        let query = firebase.firestore().collection('register')
        let checkEmail = await query
          .where('email', '==', values.email)
          .get()
          .then(querySnapshot => {
            let getDataArray = []
            querySnapshot.forEach(function(doc) {
              getDataArray.push(doc.data())
            })
            return getDataArray
          })
        let checkMobile = await query
          .where('telephone', '==', values.telephone)
          .get()
          .then(querySnapshot => {
            let getDataArray = []
            querySnapshot.forEach(function(doc) {
              getDataArray.push(doc.data())
            })
            return getDataArray
          })
        if (checkEmail.length > 0) {
          alert('ตรวจพบ Email ซ้ำ กรุณาตรวจสอบ')
          this.setState({ setLoad: false })
          return false
        }
        if (checkMobile.length > 0) {
          alert('ตรวจพบเบอร์โทรศัพซ้ำ กรุณาตรวจสอบ')
          this.setState({ setLoad: false })
          return false
        }
        query
          .add(checkObj)
          .then(resfunction => {
            axios.get(
              'https://us-central1-form-register-f433e.cloudfunctions.net/copyFormRegisterToSheet'
            )
            this.setState({ setLoad: false })
            SelectPage('3')
          })
          .catch(e => {
            console.log('e', e)
            alert('ทำรายการไม่สำเร็จกรุณาลองใหม่อีกครั้ง')
            this.setState({ setLoad: false })
            return
          })
      } else {
        alert('ทำรายการไม่สำเร็จ กรุณาแจ้งเจ้าหน้าที่')
        this.setState({ setLoad: false })
      }
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 16,
          offset: 8
        }
      }
    }
    const { setLoad } = this.state
    return (
      <DivMenu>
        <Form onSubmit={e => this.handleSubmit(e, this.props)}>
          <Form.Item {...formItemLayout} label="ชื่อ (ภาษาไทย)">
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก ชื่อ'
                }
              ]
            })(<Input placeholder="ชื่อ" />)}
          </Form.Item>
          <Form.Item {...formItemLayout} label="นามสกุล (ภาษาไทย)">
            {getFieldDecorator('lastName', {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก นามสกุล'
                }
              ]
            })(<Input placeholder="นามสกุล" />)}
          </Form.Item>
          <Form.Item {...formItemLayout} label="อีเมล">
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'กรุณากรอกรูปแบบ E-mail ให้ถูกต้อง'
                },
                {
                  required: true,
                  message: 'กรุณากรอก E-mail'
                }
              ]
            })(<Input placeholder="อีเมล" />)}
          </Form.Item>
          <Form.Item {...formItemLayout} label="เพศ">
            {getFieldDecorator('gender', {
              rules: [
                {
                  required: true,
                  message: 'กรุณาเลือกเพศ'
                }
              ]
            })(
              <Radio.Group>
                <Radio value="หญิง">หญิง</Radio>
                <Radio value="ชาย">ชาย</Radio>
              </Radio.Group>
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="อายุ">
            {getFieldDecorator('age', {
              rules: [
                {
                  required: true,
                  message: 'กรุณาเลือกช่วงอายุ'
                }
              ]
            })(
              <Radio.Group>
                <Radio value="ต่ำกว่า 20 ปี">ต่ำกว่า 20 ปี</Radio>
                <Radio value="20-30 ปี">20-30 ปี</Radio>
                <Radio value="30-40 ปี">30-40 ปี</Radio>
                <Radio value="มากกว่า 40 ปี">มากกว่า 40 ปี</Radio>
              </Radio.Group>
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="เบอร์โทรศัพท์">
            {getFieldDecorator('telephone', {
              rules: [{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }]
            })(<Input placeholder="เบอร์โทรศัพท์" />)}
          </Form.Item>
          <Form.Item {...formItemLayout} label="Line ID">
            {getFieldDecorator('lineId')(<Input placeholder="Line ID" />)}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="สาขาที่ท่านมาใช้บริการ ยามาโกย่า ราเมง">
            {getFieldDecorator('shop', {
              rules: [
                {
                  required: true,
                  message: 'กรุณาเลือกร้านค้า'
                }
              ]
            })(
              <Select placeholder="กรุณาเลือกร้าน" style={{ width: '100%' }}>
                <Option value="The Up พระราม 3">The Up พระราม 3</Option>
                <Option value="Siam square ซอย 7">Siam square ซอย 7</Option>
                <Option value="ถ.สุรวงศ์">ถ.สุรวงศ์</Option>
                <Option value="ซ.ทองหล่อ">ซ.ทองหล่อ</Option>
              </Select>
            )}
          </Form.Item>
          <Form.Item {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginBottom: '1rem' }}
              loading={setLoad}>
              ลงทะเบียน
            </Button>
          </Form.Item>
        </Form>
      </DivMenu>
    )
  }
}
const WrappedFromRegister = Form.create({ name: 'register' })(FromRegister)
export default WrappedFromRegister
